import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        const res = await http.get(buildUrlFromLocation("/zones/list?limit=200"));
        return res.data;
    },
    async getBrandZone(zoneId) {
        console.assert(typeof zoneId === "number");
        const res = await http.get(buildUrlFromLocation(`/admin/brand-zones/${zoneId}`));
        return res;
    },
    async updateBrandZoneParameters(brandZoneId, params) {
        return await http.put(buildUrlFromLocation(`/admin/brand-zones/${brandZoneId}/params`), params);
    },
    async addComponentsFromZone(zoneOld, zoneNew, payload) {
        const res = await http.put(buildUrlFromLocation("/admin/zones/copy/" + zoneOld + "/to/" + zoneNew), payload);
        return res;
    },
    async update(zoneId, payload) {
        const res = await http.put(buildUrlFromLocation("/admin/zones/" + zoneId), payload);
        return res;
    },
    async create(payload) {
        const res = await http.post(buildUrlFromLocation("/admin/zones"), payload);
        return res;
    },
    async addZoneToBrand(zoneId, zone) {
        const res = await http.post(buildUrlFromLocation("/admin/zones/" + zoneId), zone);
        return res.data;
    },
    async getZone(zone) {
        return await http.get(buildUrlFromLocation("/admin/zones/" + zone));
    },
    async search(search) {
        return await http.get(buildUrlFromLocation("/admin/zones?search=" + encodeURI(search)));
    }
};



// WEBPACK FOOTER //
// ./src/services/zone.js